import { useCallback, useMemo } from "react";

import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";
import { gql, client } from "../../bit/board/hooks/useGraphQLClient";

import Modal from "../../components/Modal";

// import useEventTracking from "../../bit/tracking/useEventTracking";
import { useDebounceStatus } from "../../lib/hooks/useDebounceStatus";
import { useTimeoutFunction } from "../../lib/hooks/useTimeoutFunction";

const MUTATION_ACCESS_EVENT_SEND_MESSAGE = gql`
  mutation accessEventSendMessage($id: ID!) {
    accessEventSendMessage(id: $id) {
      id
    }
  }
`;

const Message = () => {
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();

  // const { trackEvent } = useEventTracking();

  const { status: requestStatus } = useQuery(
    [`access/event/${id}/message`],
    () => {
      return client.request(MUTATION_ACCESS_EVENT_SEND_MESSAGE, {
        id,
      });
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      onSuccess() {
        // trackEvent({
        //   type: "message_send",
        //   value: "success",
        // });
      },
      onError() {
        // trackEvent({
        //   type: "message_send",
        //   value: "error",
        // });
      },
    },
  );

  const onDismiss = useCallback(() => {
    /**
     * Redirect to previous route in case of error so you can retry
     */
    if (requestStatus === "error") {
      return navigate(-1);
    }

    return navigate(`/`, { replace: true });
  }, [requestStatus]);

  const status = useDebounceStatus(requestStatus, 1500);

  const timeout = useMemo(() => {
    if (status === "error") {
      return 10000;
    }

    if (status === "success") {
      return 3000;
    }

    return 0;
  }, [status]);

  useTimeoutFunction(onDismiss, timeout);

  return (
    <Modal
      title={<Trans i18nKey={`message:status.${status}.title`} />}
      message={<Trans i18nKey={`message:status.${status}.message`} />}
      status={status}
      onDismiss={onDismiss}
    />
  );
};

export default Message;
